class FreeItem extends HTMLElement {
  connectedCallback() {
    this.onButtonClick = this.onButtonClick.bind(this);
    this.attachListener();

    document.addEventListener('cart-drawer:render', () => this.attachListener());
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.attachListener());
    }
  }

  attachListener() {
    // Generic selector for all cart-drawer free/upsell add buttons.
    const selectors = [
      '[data-free-item-trigger]',
      '#free-cleaner-button',
      '#upsell-cleaner-button'
    ];
    selectors.forEach((sel) => {
      const buttons = document.querySelectorAll(sel);
      buttons.forEach((btn) => {
        if (!btn || btn.dataset.freeItemBound === 'true') return;
        btn.dataset.freeItemBound = 'true';
        btn.addEventListener('click', this.onButtonClick);
      });
    });
  }

  async onButtonClick(e) {
    e.preventDefault();
    const btn = e.currentTarget;
    const variantId =
      btn.dataset.variantId || btn.dataset.cleanerId || '53997650084108';

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      const data = await res.json();

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-drawer',
          productVariantId: variantId,
          cartData: data,
        });
      }

      if (btn.closest('.cart-drawer__promo')?.remove());
    } catch (err) {
      console.error('❌ Error adding upsell item:', err);
    } finally {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
    }
  }
}

customElements.define('free-item', FreeItem);